(function (module) {
    'use strict';

    function deviceReportingCtrl() {
    }

    module
        .component('deviceReporting', {
            templateUrl: '/js/components/device-reporting/device-reporting.html',
            controller: deviceReportingCtrl,
            bindings: {
                parameter: '<',
                unit: '@',
                online: '<',
                min1: '<',
                min2: '<',
                mid1: '<',
                mid2: '<',
                max1: '<',
                iconMin: '@',
                iconMid: '@',
                iconMax: '@'

            }
        });
})(angular.module('rocket.components'));
